var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    fill: "url(#pattern0_53_56)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_53_56",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_56",
    transform: "matrix(0.00611111 0 0 0.0111111 0.225 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_56",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACuUlEQVR4nO2czU4UQRSFZ6VGjVG3ugcWPIIEo/FJcHSh+ALyGOAb+PMIoibiwp+VugPFhWwmk0wy3ed0r6+5oRed2DBVDZluqPMllZDQVdP1ceZ2VyXUYCCEEEIIIYQQQgghhBDiOMzsEslnJL+RLEiaGq1y8ZXkupldPFGKyrK8DeCnxPLYcAH44a5aJ1mSGSW7VbKrcqEywSgHT9uI9pos0Yxy8KWNaEeiGeWAbURLMuMdSDTnExyJZk9FCyGEEEIIIURv0V4HtQRnjze8lGhKtHWdQiWa3YtT6WD3UlWjKdHWdeKUaHYvSaWD3QtUjWa/mhYslGjrOoVKNLsXp9LB7qUmWaMBvAWwluf5wmg0uuLNfwYwJLnT0Oej/65+PYBFAA8BbEs0/xO2C+BOQHDuAzgA8JfkvVnXA1ghuadE8zCV0+n0esg31BNL8oU3M7sc0ifLshtHfBuSKh27oZIdAG9qZeZ1aL9K9q9kRSOgXNTmstwwxnJE/9UkRQPYjpkLgI2GMTYix3ifoui1yLk0vnVEih4mJzrP84XIufxpGGc/UvRicqLH4/HVyLk0/SNqETOGf6ZEtxONQQSTyeRacqLz+NKxfwqlYyk50dDDcG6i353C693zyDE+JJdoHopameOC5W7ofZ070ST3fHkcOh8Ar2p/pJeh/bIsu0nyd8qizRciobJ9I4nkFsnNiE0ll/wp5p7Oq2irNnxWZ82nKIoH1TbpgW+ZBpaL4CSnINq8+V6EL5P9NcwXF9VG/hKAx0ekcgfAI7/Gr/U+1fXD0AdfkqLZkybRlGhLPdE6GIXRovM2onXUD+dz1M96119Dnr32JFq0Hy3mR4z14ObtLDQA383swuAEBwxKNmdLLsvyVivJ9WT7eW5ef/SAZF2w89nLReskCyGEEEIIIYQQQgghxCAZ/gFXpF0dfYGD9gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.e95c472a1f5a87e30d7a3ef012e87186.svg";
export { ForwardRef as ReactComponent };